// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be0fcce1","239":"cf6d6679","667":"b85e2eeb"}[chunkId] + ".chunk.js";
};